const violet = {
  25: "#FBFAFF",
  50: "#F5F3FF",
  100: "#ECE9FE",
  200: "#DDD6FE",
  300: "#C3B5FD",
  400: "#A48AFB",
  500: "#875BF7",
  600: "#7839EE",
  700: "#6927DA",
  800: "#5720B7",
  900: "#491C96",
  950: "#2E125E",
};

export default violet;
